import React from 'react';
import { motion } from 'framer-motion';
import { Dumbbell, Heart, Activity, Brain } from 'lucide-react';
import { HealthMetrics } from '../../types/health';

interface StrainBreakdownProps {
  metrics: HealthMetrics;
}

export function StrainBreakdown({ metrics }: StrainBreakdownProps) {
  const activities = [
    {
      name: 'Morning Workout',
      type: 'Strength Training',
      duration: '45 min',
      strain: 8.4,
      icon: <Dumbbell className="w-4 h-4" />,
      heartRate: {
        avg: 142,
        max: 165
      }
    },
    {
      name: 'Afternoon Walk',
      type: 'Recovery',
      duration: '30 min',
      strain: 2.1,
      icon: <Activity className="w-4 h-4" />,
      heartRate: {
        avg: 98,
        max: 112
      }
    },
    {
      name: 'Evening Yoga',
      type: 'Mobility',
      duration: '20 min',
      strain: 1.8,
      icon: <Brain className="w-4 h-4" />,
      heartRate: {
        avg: 85,
        max: 95
      }
    }
  ];

  return (
    <div className="theme-card p-6">
      <h3 className="text-lg font-semibold mb-6">Activity Breakdown</h3>
      <div className="space-y-4">
        {activities.map((activity, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-muted/30 p-4 rounded-lg"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                  {activity.icon}
                </div>
                <div>
                  <div className="font-medium">{activity.name}</div>
                  <div className="text-sm text-muted-foreground">{activity.type}</div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-sm font-medium">{activity.strain.toFixed(1)}</div>
                <div className="text-xs text-muted-foreground">strain</div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-3 gap-4 text-sm">
              <div>
                <div className="text-muted-foreground">Duration</div>
                <div className="font-medium">{activity.duration}</div>
              </div>
              <div>
                <div className="text-muted-foreground">Avg HR</div>
                <div className="font-medium">{activity.heartRate.avg} bpm</div>
              </div>
              <div>
                <div className="text-muted-foreground">Peak HR</div>
                <div className="font-medium">{activity.heartRate.max} bpm</div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}